import {
  PaginatedResultOfGetUserTaskResponseFromJSON,
  UserTasksApi,
  type PaginatedResultOfGetUserTaskResponse,
  type UserTaskStatus,
} from "@/openapi/generated";

export type TenantUserTasksQuery = {
  page?: number;
  pageSize?: number;
  assigneeUserId?: number;
  status?: UserTaskStatus;
  overdue?: boolean;
  xTenantID?: number;
};

/** Admin tenant-wide task list until OpenAPI client is regenerated. */
export class TenantUserTasksApi extends UserTasksApi {
  async apiUserTasksTenantGet(
    requestParameters: TenantUserTasksQuery = {},
  ): Promise<PaginatedResultOfGetUserTaskResponse> {
    const queryParameters: Record<string, string | number> = {};

    if (requestParameters.page != null) {
      queryParameters.page = requestParameters.page;
    }
    if (requestParameters.pageSize != null) {
      queryParameters.pageSize = requestParameters.pageSize;
    }
    if (requestParameters.assigneeUserId != null) {
      queryParameters.assigneeUserId = requestParameters.assigneeUserId;
    }
    if (requestParameters.status != null) {
      queryParameters.status = requestParameters.status;
    }
    if (requestParameters.overdue === true) {
      queryParameters.overdue = "true";
    }

    const headerParameters: Record<string, string> = {};
    if (requestParameters.xTenantID != null) {
      headerParameters["X-Tenant-ID"] = String(requestParameters.xTenantID);
    }

    const configuration = this.configuration;
    if (configuration?.accessToken) {
      const tokenString = await configuration.accessToken("Bearer", []);
      if (tokenString) {
        headerParameters.Authorization = `Bearer ${tokenString}`;
      }
    }

    const response = await this.request({
      path: "/api/user-tasks/tenant",
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return PaginatedResultOfGetUserTaskResponseFromJSON(await response.json());
  }

  async apiUserTasksIdDelete(requestParameters: {
    id: string;
    xTenantID?: number;
  }): Promise<void> {
    const headerParameters: Record<string, string> = {};
    if (requestParameters.xTenantID != null) {
      headerParameters["X-Tenant-ID"] = String(requestParameters.xTenantID);
    }

    const configuration = this.configuration;
    if (configuration?.accessToken) {
      const tokenString = await configuration.accessToken("Bearer", []);
      if (tokenString) {
        headerParameters.Authorization = `Bearer ${tokenString}`;
      }
    }

    const urlPath = `/api/user-tasks/${encodeURIComponent(requestParameters.id)}`;
    await this.request({
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
    });
  }
}
